import { render, staticRenderFns } from "./main-expertise.vue?vue&type=template&id=1bd291b8"
import script from "./main-expertise.vue?vue&type=script&lang=js"
export * from "./main-expertise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports